import React from 'react';
import { useIntl, defineMessages } from 'react-intl';

import UniversalLink from '@plone/volto/components/manage/UniversalLink/UniversalLink';

import config from '@plone/registry';

const messages = defineMessages({
  print_title_1: {
    id: 'print_title_1',
    defaultMessage: 'Ufficio Informazioni e Accoglienza Turistica (IAT-R)',
  },
  print_title_2: {
    id: 'print_title_2',
    defaultMessage:
      'Sito ufficiale di informazione turistica del Comune di Reggio Emilia',
  },
});

const HeaderBrand = () => {
  const intl = useIntl();
  const Logo = config.settings.iovisit.logo;

  return (
    <div className="iv--logo">
      <UniversalLink href="/" title={config.settings.iovisit.siteName}>
        <Logo />
        <div className="iv--brand-text">{config.settings.iovisit.siteName}</div>
        <div className="print-brand-text">
          <div>
            <div>{intl.formatMessage(messages.print_title_1)}</div>
            <div>
              <strong>Reggio Emilia Welcome</strong>
            </div>
          </div>
          <div className="subtitle">
            {intl.formatMessage(messages.print_title_2)}
          </div>
        </div>
      </UniversalLink>
    </div>
  );
};

export default HeaderBrand;
